import React, { useMemo } from 'react'

const VISIBLE_PAGES = 5

/** Renders up to five page links around the current page */
export const usePagination = (
  render: (pageIndex: number) => React.ReactNode,
  total: number,
  perPage: number,
  page: number,
): React.ReactNode[] => useMemo(() => {
  if (!total) {
    return []
  }
  const totalPages = Math.ceil(total / perPage)
  let start = Math.max(0, page - 2)
  const end = Math.min(totalPages, start + VISIBLE_PAGES)
  start += Math.min(totalPages - (start + VISIBLE_PAGES), 0)
  start = Math.max(0, start)

  const pages: React.ReactNode[] = []
  for (let pageIndex = start; pageIndex < end; pageIndex++) {
    pages.push(render(pageIndex))
  }
  return pages
}, [total, perPage, page, render])
